<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-800">
    <header class="text-center mb-10">
      <h1 class="text-4xl font-bold">Welcome to the RTAF App</h1>
      <div
        v-if="isUnassigned"
        class="mt-6 max-w-xl rounded-lg border border-amber-300 bg-amber-50 px-6 py-4 text-left text-amber-900 shadow-sm"
      >
        <h2 class="text-lg font-semibold">Account awaiting assignment</h2>
        <p class="mt-2">
          Your account was created successfully. An administrator must assign your user type and access before you can use the application.
        </p>
      </div>
    </header>
  </div>
</template>

<script>
import { useAuth } from '@/stores/auth';

export default {
  computed: {
    isUnassigned() {
      return useAuth().user.value?.user_type?.toLowerCase() === 'unassigned';
    },
  },
};
</script>